import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { ICONS } from "../constants/icons";
import { useUser } from "../contexts/UserContext";
import { ref, update } from "firebase/database";
import { database } from "../constants/firebase";
import { ROUTES } from "../App";
import useMoveTo from "../constants/navigation";
import MobileHeader from "../components/MobileHeader";

const ApplyChallenge = () => {
    const navigate = useMoveTo();
    const { currentUser } = useUser();

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [form, setForm] = useState({
        name: "",
        driveLink: "",
    });

    useEffect(() => {
        if (currentUser) {
            setForm(prev => ({
                ...prev,
                name: currentUser.name || "",
            }));
        }
    }, [currentUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        if (!currentUser) return;

        if (!form.driveLink) {
            window.showToast("Please enter Google Drive link", "error");
            return;
        }

        setIsSubmitting(true);

        try {
            const uid = currentUser.uid;

            // IMPORTANT: use your month-based challenge id
            const now = new Date();
            const monthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

            const applicationData = {
                name: form.name,
                driveLink: form.driveLink,
                userId: uid,
                createdAt: Date.now(),
            };

            await update(
                ref(database, `Challenges/${monthKey}/applications/${uid}`),
                applicationData
            );

            window.showToast("Applied successfully!", "success");
            navigate(ROUTES.DASHBOARD, { replace: true });

        } catch (err) {
            console.error("Error applying challenge:", err);
            window.showToast("Failed to apply challenge", "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="h-screen bg-white text-black dark:bg-[#1A1A1A] dark:text-white overflow-y-auto">
            <MobileHeader title={'Apply Challenge'} isBackBtn={true} />

            <div className="flex">
                <Sidebar />

                <main className="flex-1 h-screen pt-5 pb-24 md:pb-20 px-6 overflow-y-auto">

                    <div className="flex items-center justify-between">
                        <button onClick={() => navigate(-1)} className="flex-shrink-0 md:block hidden">
                            <img src={ICONS.arrowBack} className="w-4 h-4 md:w-5 md:h-5 grayscale brightness-0 dark:invert" alt="Back" />
                        </button>
                        <h2 className="text-2xl md:text-3xl font-semibold hidden md:block">
                            Apply Challenge
                        </h2>
                        <div />
                    </div>

                    <div className="max-w-md mx-auto md:pt-10 pt-3 space-y-6">

                        {/* Name */}
                        <input
                            type="text"
                            name="name"
                            placeholder="Your Name"
                            value={form.name}
                            onChange={handleChange}
                            className="w-full rounded-xl px-4 py-3 bg-[#F5F9FE] dark:bg-white text-black border"
                        />

                        {/* Google Drive Link */}
                        <input
                            type="text"
                            name="driveLink"
                            placeholder="Google Drive Video Link"
                            value={form.driveLink}
                            onChange={handleChange}
                            className="w-full rounded-xl px-4 py-3 bg-[#F5F9FE] dark:bg-white text-black border"
                        />

                        {/* Submit Button */}
                        <button
                            onClick={handleSave}
                            className="bg-primary text-white text-lg font-semibold py-3 rounded-xl w-full mt-4"
                        >
                            {isSubmitting ? "Submitting..." : "Submit Challenge"}
                        </button>
                    </div>

                </main>
            </div>
        </div>
    );
};

export default ApplyChallenge;